import * as AccordionPrimitive from '@radix-ui/react-accordion'
import * as React from 'react'

import { cn } from '../utils'
import { Icon } from './icon'

const Accordion = AccordionPrimitive.Root

const AccordionItem = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({ className, ...props }, ref) => (
  <AccordionPrimitive.Item ref={ref} className={cn('border-b', className)} {...props} />
))
AccordionItem.displayName = 'AccordionItem'

const AccordionTrigger = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Header
    className={cn('flex items-center justify-between py-4 font-medium', className)}
  >
    <div className="flex flex-1 items-center">
      <AccordionPrimitive.Trigger
        className="flex items-center justify-between transition-all hover:underline [&[data-state=open]>.arrow]:rotate-90"
        {...props}
      >
        {children}
      </AccordionPrimitive.Trigger>
    </div>
    <AccordionPrimitive.Trigger
      ref={ref}
      className="flex -rotate-90 items-center justify-between opacity-50 transition-all hover:underline hover:opacity-100 [&[data-state=open]>.arrow]:-rotate-90"
      {...props}
    >
      <Icon
        name="triangle"
        weight="fill"
        size={12}
        className="arrow shrink-0 transition-transform duration-200"
      />
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
))
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName

const AccordionContent = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    className={cn(
      'data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden transition-all',
      className,
    )}
    {...props}
  >
    <div>{children}</div>
  </AccordionPrimitive.Content>
))
AccordionContent.displayName = AccordionPrimitive.Content.displayName

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent }
